export default "__VITE_PUBLIC_ASSET__22be7ceb__"